import { Alert, AlertTitle, Box, Button, Typography } from "@mui/material";

export type BankAccountProblemAlertProps = {
  severity: "warning" | "error" | "info";
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  isActionLoading?: boolean;
};

const BUTTON_COLOR_BY_SEVERITY = {
  error: "error",
  warning: "warning",
  info: "primary",
} as const;

export const BankAccountProblemAlert = ({
  severity,
  title,
  description,
  actionLabel,
  onAction,
  isActionLoading,
}: BankAccountProblemAlertProps) => (
  <Alert severity={severity}>
    <AlertTitle>{title}</AlertTitle>
    <Typography variant="body2">{description}</Typography>
    {actionLabel && onAction && (
      <Box mt={2}>
        <Button
          variant="contained"
          color={BUTTON_COLOR_BY_SEVERITY[severity]}
          onClick={onAction}
          disabled={isActionLoading}
          size="small"
          sx={{
            textTransform: "none",
            ...(severity === "warning"
              ? {
                  bgcolor: "warning.dark",
                  color: "common.white",
                  "&:hover": { bgcolor: "warning.dark" },
                }
              : {}),
          }}
        >
          {actionLabel}
        </Button>
      </Box>
    )}
  </Alert>
);
